export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8147.c3d304bd.jpg";